module.exports = __webpack_public_path__ + "src/assets/img/learning.ed34b6da.png";